import * as constants from "../../constants";

const communitySolarInitState = {
  approvals: {},
  lmiTypes: [],
  documents: [],
  approval: null
};

export function communitySolar(state = communitySolarInitState, action) {
  switch (action.type) {
    case constants.LMI_APPROVAL_LIST_APPROVALS_SUCCESS:
      return {
        ...state,
        approvals: {
          ...state.approvals,
          ...action.payload,
          // append only for a Load More continuation (page > 0, 0-indexed);
          // a page-0 fetch always replaces, mirroring csEnrollments below
          lmi_approval: Number(action.payload.page) > 0
            ? (state.approvals?.lmi_approval || []).concat(action.payload?.lmi_approval || [])
            : (action.payload?.lmi_approval || []),
        }
      }
    case constants.CS_ENROLLMENTS_LIST_SUCCESS:
      if (!state.csEnrollments) {
        return {
          ...state,
          csEnrollments: {
            ...state.csEnrollments,
            ...action.payload 
          }
        }
      } else {
        return {
          ...state,
          csEnrollments: {
            ...state.csEnrollments,
            ...action.payload,
            // append only for a Load More continuation (same status, page > 1);
            // a page-1 fetch always replaces — refetching the same status used
            // to concat duplicates (GX-3698)
            list: state.csEnrollments.status === action.payload.status &&
              Number(action.payload.page) > 1
              ? (state.csEnrollments.list || []).concat(action.payload?.list || [])
              : action.payload?.list || [],
          }
        }
      }
    case constants.CS_ENROLLMENTS_LIST_CLEAR:
      return {
        ...state,
        csEnrollments: {}
      }
    case constants.LMI_APPROVAL_GET_LMI_TYPES_SUCCESS:
      return {
        ...state,
        lmiTypes: action.payload.lmi_types
      }
    case constants.LMI_APPROVAL_GET_LMI_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: action.payload.files
      }
    case constants.LMI_APPROVAL_GET_LMI_DETAILS_SUCCESS:
      return {
        ...state,
        approval: action.payload.meter
      }
    default:
      return state;
  }
}
